// Site-wide filter persistence (localStorage). Shared across all pages so that
// navigating between manager, finance, and route pages preserves selections.
const STORAGE_KEY = "nds.filters";

const canUseStorage = () => typeof window !== "undefined" && !!window.localStorage;

export const getFilters = () => {
    if (!canUseStorage()) return {};
    try {
        return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
    } catch {
        return {};
    }
};

export const saveFilter = (name, value) => {
    if (!canUseStorage()) return;
    const filters = getFilters();
    const next = { ...filters, [name]: value || "" };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
};
